import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useAdditionalSalesRedesign = (): boolean =>
  useSelector(selectAuthData)?.commonData?.additionalSalesRedesignEnabled === true

export default useAdditionalSalesRedesign
